import React from "react";
import {useFixedHeader} from "../../../../utils/headerHelper";
import intl from "react-intl-universal";

export function CaseShow() {
    useFixedHeader();

    return (
        <>
            <main className="main-content">
                <header
                    className="page-header large image-background qa-header-bg dark-color center no-padding"
                    data-stellar-background-ratio="0.3">
                    <div className="mask">
                        <div className="container v-align-center">
                            <div className="row">
                                <div className="col-md-12">
                                    <h1 className="x-large">{intl.get('cases')}</h1>
                                    <div>
                                        <i className="icon-glyph-10 medium"></i><i className="icon-glyph-10 medium"></i><i
                                        className="icon-glyph-10 medium"></i><i className="icon-glyph-10 medium"></i><i
                                        className="icon-glyph-10 medium"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                <div style={{fontSize: '30px', textAlign: 'center', marginTop: '20vh'}}>
                    {intl.get('qidai')}
                </div>
            </main>
        </>
    )
}
